// ShopSkeleton.jsx
import "./shopSkeleton.css";

export default function ShopSkeleton() {
	return (
		<div className="sf-shop-container sf-skeleton-bg">
			{/* HERO IMAGE */}
			<div className="sf-skeleton-box sf-skeleton-hero" />

			<div className="sf-shop-mobile-div">
				{/* TITLE */}
				<div className="sf-skeleton-line sf-skeleton-title" />
				<div className="sf-skeleton-line sf-skeleton-subtitle" />

				{/* RATING */}
				<div className="sf-skeleton-line sf-skeleton-rating" />

				{/* TABS */}
				<div className="sf-skeleton-tabs">
					<div className="sf-skeleton-tab" />
					<div className="sf-skeleton-tab" />
					<div className="sf-skeleton-tab" />
				</div>

				{/* SERVICES LIST */}
				<div className="sf-skeleton-services">
					{Array.from({ length: 4 }).map((_, i) => (
						<div className="sf-skeleton-service-item" key={i}>
							<div className="sf-skeleton-line sf-skeleton-line-long" />
							<div className="sf-skeleton-line sf-skeleton-line-medium" />
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
